<template>
  <div>
    <el-tooltip content="一覧に戻る"
        placement="top"
        effect="light">
      <BaseButton
          v-show="isShow"
          class="detail-header-back"
          icon="fas fa-arrow-left"
          @click="backPage" />
    </el-tooltip>
  </div>
</template>

<script>

import BaseButton from '@/components/atoms/BaseButton'

export default {
  name: 'BaseBackButton',
  components: {
    BaseButton
  },
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    returnDestination: {
      type: String,
      default: null
    }
  },
  methods: {
    /**
     * 戻り先に設定されたページに遷移します。
     */
    backPage: function () {
      this.$router.push({ path: this.returnDestination })
    }
  }
}
</script>
